// extracted by mini-css-extract-plugin
export default {"formLayout":"SkinTypeForm-module-formLayout-uT8Wa"};